import axios from "axios";
import React from "react";
import { useQuery } from "react-query";

const CustomAdd = React.memo(function CustomAdd() {
  const { data: exchangeRate, isLoading } = useQuery({
    queryKey: ["advertisements"],
    queryFn: async () => {
      const response = await axios.request({
        method: "GET",
        url: process.env.REACT_APP_BASE_URL + "/api/advertisements",
        headers: {
          Authorization: process.env.REACT_APP_API_KEY,
        },
      });
      return response.data.data;
    },
  });
  return (
    <div className="container">
      <div className="row justify-content-center align-items-center">
        {isLoading
          ? // Show 3 skeleton advertisement cards while loading
            Array.from({ length: 3 }).map((_, index) => (
              <div key={`skeleton-${index}`} className="col-lg-4 col-md-6 col-sm-12 card-holder">
                <div className="card card-money-exchange">
                  <div className="card-body card-body-money-exchange">
                    <div className="row">
                      <div className="col-2">
                        <div style={{ width: "50px", height: "50px", borderRadius: "50%", backgroundColor: "#f0f0f0" }}></div>
                      </div>
                      <div className="col-10">
                        <div style={{ height: "20px", backgroundColor: "#f0f0f0", borderRadius: "4px", marginBottom: "8px" }}></div>
                      </div>
                    </div>
                    <div style={{ height: "16px", backgroundColor: "#e0e0e0", borderRadius: "4px", marginBottom: "12px", marginTop: "12px" }}></div>
                    <div style={{ height: "32px", backgroundColor: "#f0f0f0", borderRadius: "4px", width: "120px" }}></div>
                  </div>
                </div>
              </div>
            ))
          : exchangeRate &&
            exchangeRate.map((element, index) => {
              return (
                <div key={index} className="col-lg-4 col-md-6 col-sm-12 card-holder">
                  <div className="card card-money-exchange">
                    <div className="card-body card-body-money-exchange">
                      <div className="row">
                        <div className="col-2">
                          <img className="img-fluid" src={element.image_path} alt="" />
                        </div>
                        <div className="col-10">
                          <h1 className="live-exchange-rate-text">{element.name}</h1>
                          {/* <h1 className="live-exchange-rate-text">Peepal Has Your Back</h1> */}
                        </div>
                      </div>

                      <p className="live-exchange-rate">{element.detail}</p>
                      <a href={element.link} target="_blank" rel="noopener noreferrer" className="btn btn-send-money">
                        Read more
                      </a>
                    </div>
                  </div>
                </div>
              );
            })}
      </div>
    </div>
  );
});

export default CustomAdd;
